// extracted by mini-css-extract-plugin
export default {"text_middle":"Middle_text_middle__M0Zle"};